import React from 'react';

/**
 * Subtle cyan gradient divider used between homepage sections.
 * Centered horizontal line that fades in from transparent → primary → transparent,
 * with a soft glow dot in the middle to match the industrial/glass aesthetic.
 */
const SectionDivider = () => {
  return (
    <div
      aria-hidden="true"
      className="relative flex items-center justify-center py-2 bg-background"
    >
      <div className="h-px w-full max-w-5xl bg-gradient-to-r from-transparent via-primary/60 to-transparent" />
      <div className="absolute h-1.5 w-1.5 rounded-full bg-primary shadow-[0_0_12px_2px_hsl(var(--primary)/0.7)]" />
    </div>
  );
};

export default SectionDivider;
